export const StatusTypes = {
  NEW: 'NEW',
  INCOMPLETE: 'INCOMPLETE',
  SUBMITTED: 'SUBMITTED',
  SUBMITTED_SYNC_SUCCESS: 'SUBMITTED_SYNC_SUCCESS',
  SUBMITTED_SYNC_FAILED: 'SUBMITTED_SYNC_FAILED'
};

export const EventTypes = {
  TEXT_FIELD_TYPING: 'TEXT_FIELD_TYPING',
  VALUE_CHANGE: 'VALUE_CHANGE',
  ACCESS_ASSESSMENT: 'ACCESS_ASSESSMENT',
  ASSESSMENT_STATUS_CHANGE: 'ASSESSMENT_STATUS_CHANGE',
  DDE_ACTIONS_TRIGGERED: 'DDE_ACTIONS_TRIGGERED'
};

export const TemplateEventTypes = {
  TEMPLATE_TEXT_FIELD_TYPING: 'TEMPLATE_TEXT_FIELD_TYPING',
  TEMPLATE_VALUE_CHANGE: 'TEMPLATE_VALUE_CHANGE',
  ACCESS_TEMPLATE: 'ACCESS_TEMPLATE',
  TEMPLATE_STATUS_CHANGE: 'TEMPLATE_STATUS_CHANGE'
};

export const EventEmitterTypes = {
  TOGGLE_MOBILE_SIDEBAR: 'TOGGLE_MOBILE_SIDEBAR',
  TOGGLE_ADD_PARTICIPANTS: 'TOGGLE_ADD_PARTICIPANTS',
  SCROLL_INTO_VIEW: 'SCROLL_INTO_VIEW',
  TOGGLE_VISIBLE_CATEGORY: 'TOGGLE_VISIBLE_CATEGORY',
  SHOW_LOADER: 'SHOW_LOADER',
  SHOW_HOME_GUIDED_TOUR: 'SHOW_HOME_GUIDED_TOUR',
  FOCUS_PARTICIPANT_OPTION: 'FOCUS_PARTICIPANT_OPTION'
};

export const SidebarViews = Object.freeze({
  SECTIONS: 'SECTIONS',
  FILTERS: 'FILTERS',
  PARTICIPANT_DETAILS: 'PARTICIPANT_DETAILS',
  OVERVIEW: 'OVERVIEW'
});

export const DateValues = {
  DATE_FORMAT: 'YYYY-MM-DD',
  MIN_DATE: '1753-01-01',
  MAX_DATE: '9999-12-31'
};

export const DeviceWidth = {
  MOBILE: 834
};

export const DisplayControlType = {
  NONE: 'NONE',
  GRID: 'GRID',
  SINGLE_COLUMN: 'SINGLE_COLUMN',
  TEXTFIELD: 'TEXTFIELD',
  TEXTAREA: 'TEXTAREA'
};

export const Languages = {
  CHINESE: 'zh',
  ENGLISH: 'en',
  FRENCH: 'fr',
  GERMAN: 'de',
  ITALIAN: 'it',
  JAPANESE: 'ja',
  PORTUGUESE: 'pt',
  SPANISH: 'es',
  KOREAN: 'ko'
};

export const SIDEBAR_TOGGLE_DURATION = 3100;

export const OTHER_TEXT_MAX_CHARACTERS = 1000;

export default {
  StatusTypes,
  EventTypes,
  SidebarViews,
  DeviceWidth,
  DisplayControlType
};
